var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3"},[_c('b-pagination',{attrs:{"pills":"","total-rows":_vm.innerValue.total,"per-page":_vm.innerValue.perPage,"first-number":"","last-number":""},model:{value:(_vm.innerValue.currentPage),callback:function ($$v) {_vm.$set(_vm.innerValue, "currentPage", $$v)},expression:"innerValue.currentPage"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }